import React from 'react';
import { Button, Drawer } from "@mui/material";
import LandingCommunityLogsUpdateIssued from "./LandingCommunityLogsUpdateIssued";
import LandingCommunityLogsUpdateRedeemed from "./LandingCommunityLogsUpdateRedeemed";
import RedeemVoucherShowHeaderOwner from "../RedeemVoucher/RedeemVoucherShowHeaderOwner";
export default function LandingCommunityLogsUpdate({
    open,
    setOpen,
    row,
    mode,
    loading,
    setLoading,
    animal,
    setAnimal,
    microchips,
    setRow
}) {
    const [mode1, setMode1] = React.useState(mode || 'redeemed');

    // Define any additional states that are needed by LandingCommunityLogsUpdateRedeemed
    const [showModal, setShowModal] = React.useState(false);
    const [reloadOriginal, setReloadOriginal] = React.useState(false);
    const [verified, setVerified] = React.useState(false);

    // We can use the passed 'row' and 'setRow' as 'rowInstance' and 'setRowInstance'
    const rowInstance = row;
    const setRowInstance = setRow;

    return (
        <Drawer anchor={"right"} open={open} onClose={() => setOpen(false)}>
            <div style={{ padding: 20, width: 400 }}>

                {/* 
                 If you need the mode switch buttons back, you can uncomment these:
                 <div style={{display:'flex'}}>
                     <Button disabled={mode1 === 'issued'} onClick={() => setMode1('issued')}>Issued</Button>
                     <Button disabled={mode1 === 'redeemed'} onClick={() => setMode1('redeemed')}>Redeemed</Button>
                 </div>
                */}

                {/* 
                 If you need to render Issued mode:
                 {mode1 === 'issued' && 
                     <LandingCommunityLogsUpdateIssued 
                         row={row} 
                         setOpen={setOpen} 
                         setLoading={setLoading} 
                     />} 
                */}
 <div className={"animal-form"}>
            {/* <RedeemVoucherShowHeaderOwner row={row}  /> */}
            {/* <ShowEmailDisable storeEmailAllowed={storeEmailAllowed} emailAllowed={emailAllowed}/>

            <div>
                <ShowVerifiedButton row={row} {...{storeOwnerNoVerification, storeOwnerNoChange,setChange}}/>
            </div> */}

            {/* {mode1 === 'redeemed' && ( */}
                    <LandingCommunityLogsUpdateRedeemed
                        row={row}
                        open = {open}
                        setOpen={setOpen}
                        loading = {loading}
                        setLoading={setLoading}
                        animal={animal}
                        setAnimal={setAnimal}
                        rowInstance={rowInstance}
                        setRowInstance={setRowInstance}
                        setShowModal={setShowModal}
                        showModal={showModal}
                        reloadOriginal={setReloadOriginal}
                        microchips={microchips}
                        verified={verified}
                        key={animal && animal.id ? animal.id : 'no-animal-key'}
                    />
                {/* )} */}

        </div>
                
            </div>
        </Drawer>
    );
}
